import React from "react";
import { motion, useReducedMotion } from "framer-motion";

export const PETROL = "#3F6A70";
export const GOLD = "var(--accent-gold)";

export function Reveal({ children, delay = 0, className = "", as = "div" }) {
  const reduce = useReducedMotion();
  const Comp = motion[as];
  if (reduce) return React.createElement(as, { className }, children);
  return (
    <Comp
      className={className}
      initial={{ opacity: 0, y: 18 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </Comp>
  );
}

export function Ornament({ className = "" }) {
  return (
    <div aria-hidden="true" className={`flex items-center justify-center gap-3 ${className}`}>
      <span className="h-px w-10 md:w-14" style={{ background: GOLD, opacity: 0.45 }} />
      <span className="w-1.5 h-1.5 rotate-45" style={{ background: GOLD, opacity: 0.7 }} />
      <span className="h-px w-10 md:w-14" style={{ background: GOLD, opacity: 0.45 }} />
    </div>
  );
}

export function SectionTitle({ children, testId, className = "" }) {
  return (
    <Reveal className={`text-center ${className}`}>
      <Ornament className="mb-5" />
      <h2
        data-testid={testId}
        className="font-serif-display text-[30px] sm:text-[36px] md:text-[44px] leading-[1.18] text-graphite max-w-3xl mx-auto"
      >
        {children}
      </h2>
    </Reveal>
  );
}

export function Highlight({ children, testId, className = "" }) {
  return (
    <Reveal className={`text-center ${className}`}>
      <p
        data-testid={testId}
        className="font-serif-display italic text-graphite text-[21px] sm:text-[24px] md:text-[27px] leading-[1.5] max-w-2xl mx-auto"
      >
        {children}
      </p>
    </Reveal>
  );
}

export function Prose({ children, className = "" }) {
  return (
    <Reveal
      className={`reading-prose font-body font-light text-graphite text-[16px] md:text-[17px] leading-[1.9] max-w-5xl mx-auto ${className}`}
    >
      {children}
    </Reveal>
  );
}
